export const unitToPersian = {
  ton: 'تن',
  gram: 'گرم',
  kilogram: 'کیلوگرم',
  liter: 'لیتر',
};
